import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInvoiceList3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 15.5V3.076a1 1 0 0 1 .499-.865l.992-.575a1 1 0 0 1 1-.002l1.505.864L7 2.5l1.493-.866a1 1 0 0 1 .997 0l1.505.864h.008l1.505-.864a1 1 0 0 1 1 .002l1.487.862h.008l1.505-.865a1 1 0 0 1 1 .002l.992.576a1 1 0 0 1 .499.865V18a1.5 1.5 0 0 1-1.5 1.5v0A1.5 1.5 0 0 1 16 18v-1.5a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h14.5M11 11H7.004M11 7.5H7.004M15 11h-1M15 7.5h-1"
    />
  </svg>
);
export default SvgInvoiceList3;
